// src/components/common/FloatingAddInventoryButton.js
import React, { useEffect, useState } from "react";
import { Fab, Tooltip, useTheme } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FLOATING_SPACING = 32;
const MIN_SPACING_FROM_FOOTER = 32;

const FloatingAddInventoryButton = ({
  inventoryPath, // (προαιρετικό override)
  tooltip,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  // Country prefix
  const match = location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)\b/);
  const countryPrefix = match ? `/${match[1]}` : "/el";
  // Default διαδρομή για προσθήκη προϊόντος στην αποθήκη:
  const finalInventoryPath =
    inventoryPath || `${countryPrefix}/client/inventory/add/product/inventory`;

  const [bottom, setBottom] = useState(FLOATING_SPACING);

  useEffect(() => {
    function updatePosition() {
      const footer = document.getElementById("app-footer");
      if (!footer) {
        setBottom(FLOATING_SPACING);
        return;
      }
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (footerRect.top < windowHeight && footerRect.top > 0) {
        const overlap = windowHeight - footerRect.top + MIN_SPACING_FROM_FOOTER;
        setBottom(overlap);
      } else {
        setBottom(FLOATING_SPACING);
      }
    }
    updatePosition();
    window.addEventListener("scroll", updatePosition);
    window.addEventListener("resize", updatePosition);
    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  const handleClick = () => {
    navigate(finalInventoryPath);
  };

  return (
    <Tooltip
      title={tooltip || t("add_product_inventory") || "Προσθήκη προϊόντος"}
      placement="left"
    >
      <Fab
        color="secondary"
        aria-label="add-inventory"
        onClick={handleClick}
        sx={{
          position: "fixed",
          bottom: bottom,
          right: { xs: 16, sm: 32 },
          zIndex: 1200,
          width: 64,
          height: 64,
          borderRadius: "50%",
          background: `linear-gradient(135deg, ${theme.palette.secondary.main} 60%, ${theme.palette.primary.dark})`,
          color: "#fff",
          boxShadow: theme.shadows[8],
          border: "3px solid #fff",
          transition: "bottom 0.3s cubic-bezier(.4,2,.6,1)",
          "&:hover": {
            background: `linear-gradient(135deg, ${theme.palette.primary.main} 60%, ${theme.palette.secondary.dark})`,
            color: "#fff",
            boxShadow: theme.shadows[12],
          },
        }}
      >
        <AddCircleIcon sx={{ fontSize: 34 }} />
      </Fab>
    </Tooltip>
  );
};

export default FloatingAddInventoryButton;
